'use client';

import {useRouter, useSearchParams} from 'next/navigation';
import getDefaultRouteAfterSignIn from 'src/utils/getDefaultRouteAfterSignIn';
import setLanguageCookie from 'src/utils/setLanguageCookie';
import {panelistaPrimaryColor} from 'src/utils/constants';
import getBrandStyle from 'src/utils/getBrandStyle';
import SignIn from '../SignIn';

const brandStyle = getBrandStyle({primaryColor: panelistaPrimaryColor});

interface Props {
  signUpMode: boolean;
}

const AuthenticationPage = ({signUpMode}: Props) => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const onSignInSuccess = (user: User) => {
    const returnToPath = searchParams.get('returnTo');
    const goBackRoute = returnToPath || getDefaultRouteAfterSignIn(user);

    setLanguageCookie(user.language);

    if (!user.phone) {
      router.push(`/onboarding?returnTo=${goBackRoute}`);
    } else {
      router.push(goBackRoute);
    }
  };

  const setSignUpMode = (signUpMode: boolean) => {
    router.push(signUpMode ? '/signup' : '/signin');
  };

  return (
    <div className="flex items-center justify-center grow m-[--side-padding]">
      <SignIn
        onSignInSuccess={onSignInSuccess}
        signUpMode={signUpMode}
        setSignUpMode={setSignUpMode}
        showApproveTermsStep
        brandStyle={brandStyle}
      />
    </div>
  );
};

export default AuthenticationPage;
